import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { addUnitOffers } from '../../services/unitOfferService';
import UnitOffersForm from '../unitOffer/UnitOffersForm';
import { saveAs } from 'file-saver';

const exportToJson = (values) => {
  var blob = new Blob([JSON.stringify(values)], {
    type: 'application/json'
  });
  saveAs(blob, `${Date.now()}-unit-offers-auto-gen.json`);
};
function UnitOffersAdd(props) {
  const { id } = useParams();
  const [initialValues, setInitialValues] = useState({
    courseOfferId: id,
    unitCode: '',
    unitDescription: '',
    startDate: '',
    endDate: '',
    maxRegistrations: 0,
    minRegistrations: 0
  });
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'Idle mode.'
  });

  async function onSubmit(values) {
    let payload = {
      ...values
    };
    delete values.courseOfferId;
    exportToJson(values);

    try {
      setStatus({ type: 'LOADING', message: 'Is waiting for response' });
      await addUnitOffers(payload)
        .then((res) => {
          setStatus({ type: 'SUCCESS', message: 'Succesful response' });
        })
        .catch((err) => {
          alert(err);
          setStatus({
            type: 'ERROR',
            message: 'Error/Fields should not be empty!'
          });
        });
    } catch {
      setStatus({
        type: 'ERROR',
        message: 'Start date cannot be after end date!'
      });
    }
  }

  return (
    <Modal
      title={`Add Unit Offers`}
      visible={props.isOpen}
      onCancel={() => props.toggle()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <UnitOffersForm
          initialValues={initialValues}
          setInitialValues={setInitialValues}
          onSubmit={onSubmit}
          status={status}
          setStatus={setStatus}
          visible={props.isOpen}
          courses={props.courses}
        />
      )}
    </Modal>
  );
}

export default UnitOffersAdd;
